import { connect } from 'react-redux'
import { RestaurantSearchComponent } from './RestaurantSearchComponent'
import type { RootState } from 'shared/store/reducers'
import { selectRestaurant } from 'shared/store/birthday'
import type { Dispatch } from 'redux'
import { restaurantServices } from 'shared/utils'
import type { RestaurantShortDTO } from 'shared/types'

const mapStateToProps = (state: RootState) => {
    const { restaurants } = state.birthdayPageState
    const { loading } = state.storeLocatorPageState
    const birthdayRestaurants = restaurants.map((r: RestaurantShortDTO) => {
        return {
            ...r,
            birthday:
                r.services.indexOf(restaurantServices.BIRTHDAY_BOOKING) > -1
        }
    })
    return {
        ...state.birthdayPageState,
        restaurants: birthdayRestaurants,
        loading
    }
}

const mapDispatchToProps = (d: Dispatch<any>) => ({
    selectRestaurant: (restaurant: RestaurantShortDTO) =>
        d(selectRestaurant(restaurant))
})

const RestaurantSearch = connect(
    mapStateToProps,
    mapDispatchToProps
)(RestaurantSearchComponent)

export { RestaurantSearch }
